<template>
    <div class="d-md-none d-lg-none" style="background:#fff; min-height:100vh; padding-bottom:84px;">
        <CContainer class="title-container">
        <CButton color="link" class="back-button" @click="$router.go(-1)">
            <CIcon name="cil-arrow-left" size="xl" />
        </CButton>

        <h2 class="title">Password</h2>

        <!-- VIEW / ENTER CURRENT -->
        <div class="mt-5 text-left" v-if="mode === 'view'">
            <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-101010">Password</strong>
            <div class="pw-wrap">
            <input
                v-model="currentPassword"
                :type="showCurrent ? 'text' : 'password'"
                class="custom-input-app mt-1 mb-2"
                placeholder="Your password"
            />
            <button type="button" class="pw-eye" @click="showCurrent = !showCurrent" aria-label="Toggle password">
                <img src="@/assets/img/new/eye-slash.png" class="eye-icon" alt="toggle" />
            </button>
            </div>

            <div class="text-right mt-2">
            <CButton color="link" class="p-0" @click="goForgot" style="color:#ED4C5C;">Forgot Password?</CButton>
            </div>

            <div class="btn-fixed">
                <CCol sm="12" class="p-2">
                    <CButton
                        block
                        class="custom-border-purple position-bottom" color="primary" 
                        @click="mode='edit'">
                        Edit Password
                    </CButton>
                </CCol>
            
            </div>
        </div>

        <!-- EDIT / SAVE -->
        <div class="mt-5 text-left" v-else>
            <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-101010">Password</strong>
            <div class="pw-wrap">
            <input
                v-model="newPassword"
                :type="showNew ? 'text' : 'password'"
                class="custom-input-app mt-1 mb-3"
                placeholder="Your password"
            />
            <button type="button" class="pw-eye" @click="showNew = !showNew" aria-label="Toggle new password">
                <img src="@/assets/img/new/eye-slash.png" class="eye-icon" alt="toggle" />
            </button>
            </div>

            <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-101010">Confirm New Password</strong>
            <div class="pw-wrap">
            <input
                v-model="confirmPassword"
                :type="showConfirm ? 'text' : 'password'"
                class="custom-input-app mt-1 mb-2"
                placeholder="Your password"
            />
            <button type="button" class="pw-eye" @click="showConfirm = !showConfirm" aria-label="Toggle confirm password">
                <img src="@/assets/img/new/eye-slash.png" class="eye-icon" alt="toggle" />
            </button>
            </div>

            <!-- bullets -->
            <ul class="mt-3" style="list-style:none; padding:0; font-size:14px;">
                <li :class="{ passed: lenOK }">
                    <img src="@/assets/img/new/grey-roundtick.png" class="tick-icon"/>
                    At least 8 characters
                </li>
                <li :class="{ passed: hasNumber }">
                    <img src="@/assets/img/new/grey-roundtick.png" class="tick-icon"/>
                    At least 1 number
                </li>
                <li :class="{ passed: hasUpper && hasLower }">
                    <img src="@/assets/img/new/grey-roundtick.png" class="tick-icon"/>
                    Both upper and lower case letters
                </li>
            </ul>



            <!-- bottom actions -->
            <div class="flex gap-3" style="position:fixed; left:0; right:0; bottom:16px; padding:0 16px; display:flex; gap:12px;">
            <CButton block class="custom-btn-grey text-grey mt-4" @click="mode='view'">Cancel</CButton>
            <CButton block class="custom-border-purple-wp text-white mt-4" color="primary" :disabled="!canSave" @click="savePassword">
                Save Password
            </CButton>
            </div>
        </div>
        </CContainer>
    </div>
</template>

<script>
export default {
    name: "PasswordMobile",
    data() {
        return {
        mode: "view",
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",

        showCurrent: false,
        showNew: false,
        showConfirm: false,
        };
    },
    computed: {
        lenOK()      { return this.newPassword.length >= 8; },
        hasUpper()   { return /[A-Z]/.test(this.newPassword); },
        hasLower()   { return /[a-z]/.test(this.newPassword); },
        hasNumber()  { return /\d/.test(this.newPassword); },
        matchOK()    { return this.newPassword && this.newPassword === this.confirmPassword; },
        canSave()    { return this.lenOK && this.hasUpper && this.hasLower && this.hasNumber && this.matchOK; },
    },
    methods: {
        bulletStyle(ok) {
        // gray when false, darker when true
        return { color: ok ? "#111827" : "#98A2B3" };
        },
        goForgot() {
        // optional: route to your ForgotPassword flow
        this.$router.push({ name: "ForgotPassword" });
        },
        async savePassword() {
        if (!this.canSave) return;
        // hit your API here; re-use the endpoint you already have
        // await this.$API.post(...)

        // after success:
        this.mode = "view";
        this.currentPassword = "";
        this.newPassword = "";
        this.confirmPassword = "";
        },
    },
};
</script>

<style scoped>

.pw-wrap { position: relative; }
.pw-eye {
    position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
    background: none; border: none; padding: 0; cursor: pointer;
}
.pw-eye:focus { outline: none; box-shadow: none; }
.eye-icon { width: 20px; height: 20px; opacity: .85; }


.custom-input-app { background:#F9FAFB; border:1px solid #E5E7EB; border-radius:24px; padding:12px 40px 12px 16px; }
.custom-input-app::placeholder { color:#B8BDC7; }



.tick-icon {
    width: 18px;
    margin-right: 6px;
    filter: grayscale(100%);
    opacity: 0.5;
}

.passed .tick-icon {
    filter: none;
    opacity: 1;
}

li {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    color: #98A2B3;
}

li.passed {
    color: #101010;
}


</style>
